import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { BehaviorSubject, first } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AppType } from '../../../model/app-type.model';
import { FormsPolicyholder } from '../../../model/forms.model';
import { ModalService } from '../../../services/modal.service';
import { PersistStorageKeys, PersistStorageService } from '../../../services/persist-storage.service';
import { AppState } from '../../../store';
import * as fromProcess from '../../../store/process/process.reducer';

@Component({
  selector: 'app-conclusion-remote',
  templateUrl: './conclusion-remote.component.html',
  styleUrls: ['./conclusion-remote.component.scss'],
})
export class ConclusionRemoteComponent implements OnInit {
  isTravelAgency = environment.app === AppType.TravelAgency;
  nextStepUrl$ = this.store.select(fromProcess.selectProcessNextStepUrl);
  descriptionParams$ = new BehaviorSubject<{ email: string }>({ email: '—' });

  agreementChecked = false;

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private persistStorage: PersistStorageService,
    private modalService: ModalService,
  ) {}

  ngOnInit(): void {
    const email: string | null = this.persistStorage.getJson<FormsPolicyholder>(PersistStorageKeys.FormsPolicyholder)?.emailAddress || null;

    this.descriptionParams$.next({
      email: email || '—',
    });
  }

  handleClick(): void {
    this.nextStepUrl$.pipe(first()).subscribe((url) => {
      // this.store.dispatch(fromProcess.actions.conclusionStart());
      this.modalService.closeModalAll();
      void this.router.navigate(url);
    });
  }
}
